import React, { useState } from "react";
import env from "../env/env.json";

const InfoPopupCards = () => {
  const [popupVisible, setPopupVisible] = useState(false);

  const togglePopup = () => {
    setPopupVisible(!popupVisible);
  };

  const redirectToCGU = () => {
    window.open(env.CGU);
  };

  const redirectToRGPD = () => {
    window.open(env.RGPD);
  };

  return (
    <>
      <div
        className="popup-cgu d-flex justify-content-center align-items-center"
        onClick={redirectToCGU}
      >
        <p className="text-light fw-bold m-0">CGU</p>
      </div>
      <div
        className="popup-rgpd d-flex justify-content-center align-items-center"
        onClick={redirectToRGPD}
      >
        <p className="text-light fw-bold m-0">RGPD</p>
      </div>
      {/* <div className="popup-question" onClick={togglePopup}>
        <i className="fas fa-envelope"></i>
      </div>
      {popupVisible && (
        <div
          className="card text-bg-light mb-3 shadow"
          style={{ maxWidth: "18rem", zIndex: 1000 }}
        >
          <div className="card-header d-flex justify-content-between fw-bold">
            Besoin d'aide ?
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={togglePopup}
            ></button>
          </div>
          <div className="card-body">
            <p>
              Pour tout problème technique, ou difficulté pour déposer votre
              dossier, vous pouvez remplir notre&nbsp;
              <a
                href="https://tally.so/r/me7adx"
                target="_blank"
                rel="noreferrer"
              >
                formulaire de support.
              </a>
            </p>
          </div>
        </div>
      )} */}
    </>
  );
};

export default InfoPopupCards;
